<template>
  <div class="wrapper">
    <div class="wrapper-overlay"></div>
    <e-tema-toggle icon-color="white" btn-class="auth-tema-toggle" />
    <v-card elevation="0" class="login-card">
      <div class="auth-accent-bar"></div>
      <div class="auth-orb"></div>
      <v-card-text class="pa-8">
        <div class="d-flex flex-column align-center mb-6 fade-up">
          <div class="auth-logo-badge mb-4 d-flex align-center justify-center">
            <img src="/img/logo-pontofiq-recorte.png" alt="Logo" />
          </div>
          <h1 class="auth-title">Recuperar acesso</h1>
          <p class="auth-subtitle">
            {{
              token
                ? "Crie uma nova senha para a sua conta."
                : "Vamos restabelecer a senha da sua conta."
            }}
          </p>
        </div>

        <v-alert
          v-if="mensagemEnvio"
          type="success"
          text
          dense
          class="fade-up d2 mb-0"
          id="alert-link-enviado"
        >
          {{ mensagemEnvio }}
        </v-alert>

        <ValidationObserver v-slot="{ handleSubmit }" v-else-if="!token">
          <v-form ref="form" @submit.prevent="handleSubmit(solicitarLink)" class="fade-up d2">
            <ValidationProvider name="Login" rules="required" v-slot="{ errors }">
              <v-text-field
                id="login"
                v-model="login"
                filled
                rounded
                dense
                background-color="var(--input-bg)"
                color="var(--brand)"
                prepend-inner-icon="mdi-account-outline"
                label="Login de acesso"
                hint="Enviaremos um link para o e-mail cadastrado na sua conta."
                persistent-hint
                required
                :error-messages="errors"
              />
            </ValidationProvider>
            <v-btn
              id="btn-recuperar-senha"
              type="submit"
              block
              class="auth-btn mt-6"
              :class="loginButtonClass"
              :disabled="enviando"
              :loading="enviando"
            >
              Enviar link de redefinição
            </v-btn>
          </v-form>
        </ValidationObserver>

        <ValidationObserver v-slot="{ handleSubmit }" v-else>
          <v-form ref="form" @submit.prevent="handleSubmit(redefinirSenha)" class="fade-up d2">
            <ValidationProvider name="Nova senha" rules="required|min:8" v-slot="{ errors }">
              <v-text-field
                id="nova-senha"
                v-model="novaSenha"
                filled
                rounded
                dense
                background-color="var(--input-bg)"
                color="var(--brand)"
                prepend-inner-icon="mdi-lock-outline"
                :type="mostrarSenha ? 'text' : 'password'"
                :append-icon="mostrarSenha ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                @click:append="mostrarSenha = !mostrarSenha"
                label="Nova senha"
                required
                :error-messages="errors"
              />
            </ValidationProvider>
            <ValidationProvider
              name="Confirmação da senha"
              :rules="{ required: true, is: novaSenha }"
              v-slot="{ errors }"
            >
              <v-text-field
                id="confirmar-senha"
                v-model="confirmarSenha"
                filled
                rounded
                dense
                background-color="var(--input-bg)"
                color="var(--brand)"
                prepend-inner-icon="mdi-lock-check-outline"
                :type="mostrarSenha ? 'text' : 'password'"
                label="Confirme a nova senha"
                required
                :error-messages="errors"
              />
            </ValidationProvider>
            <v-btn
              id="btn-redefinir-senha"
              type="submit"
              block
              class="auth-btn mt-4"
              :class="loginButtonClass"
              :disabled="enviando"
              :loading="enviando"
            >
              Salvar nova senha
            </v-btn>
          </v-form>
        </ValidationObserver>

        <div class="d-flex justify-center mt-6 fade-up d3">
          <a
            id="btn-voltar-login"
            @click="$router.push('/login')"
            class="auth-help-link"
            :class="{ 'animate__animated animate__headShake': animarAjuda }"
          >
            <v-icon small left>mdi-arrow-left</v-icon>
            Voltar para o login!
          </a>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ResetPasswordPage",
  data() {
    return {
      login: "",
      novaSenha: "",
      confirmarSenha: "",
      mostrarSenha: false,
      enviando: false,
      mensagemEnvio: "",
      loginButtonClass: "",
      animarAjuda: false,
    };
  },
  computed: {
    // Com token na URL (link do e-mail) a tela pede a nova senha; sem token, solicita o link.
    token() {
      return this.$route.query.token || "";
    },
    loginDoLink() {
      return this.$route.query.login || "";
    },
  },
  mounted() {
    const switchAnimarAjuda = () => {
      this.animarAjuda = !this.animarAjuda;
      setTimeout(() => switchAnimarAjuda(), 2000);
    };
    switchAnimarAjuda();
  },
  methods: {
    async solicitarLink() {
      try {
        this.enviando = true;
        const response = await this.$services.authService.solicitarRedefinicaoSenha(this.login);
        this.mensagemEnvio = response.data.message;
      } catch (error) {
        this.mostrarErro(error);
      } finally {
        this.enviando = false;
      }
    },
    async redefinirSenha() {
      try {
        this.enviando = true;
        const response = await this.$services.authService.redefinirSenha({
          login: this.loginDoLink,
          token: this.token,
          password: this.novaSenha,
          password_confirmation: this.confirmarSenha,
        });
        this.$toast.success(response.data.message);
        this.$router.replace({ name: "login" });
      } catch (error) {
        this.mostrarErro(error);
      } finally {
        this.enviando = false;
      }
    },
    mostrarErro(error) {
      const mensagem =
        error.response?.status === 429
          ? "Muitas tentativas. Aguarde um minuto e tente novamente."
          : error.response?.data?.message || error.message;
      this.$toast.danger(mensagem);
      this.loginButtonClass = "animate__animated animate__headShake";
      setTimeout(() => (this.loginButtonClass = ""), 500);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  position: absolute;
  background-image: url("../../assets/background-2.png");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 16px;
}

.wrapper-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    160deg,
    rgba(79, 0, 143, 0.58) 0%,
    rgba(124, 58, 237, 0.42) 55%,
    rgba(167, 139, 250, 0.28) 100%
  );
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  background: var(--surface) !important;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.35);
  overflow: hidden;
  animation: fadeUp 0.55s ease both;
}

.auth-accent-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4f008f 0%, #7c3aed 100%);
}

.auth-orb {
  position: absolute;
  top: -70px;
  right: -50px;
  width: 220px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.12), transparent 70%);
  pointer-events: none;
}

.auth-logo-badge {
  padding: 10px 28px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f5f0ff, #ffffff);
  border: 1px solid #e6d9fb;
  box-shadow: 0 10px 24px rgba(79, 0, 143, 0.16);
}

.auth-logo-badge img {
  display: block;
  height: 60px;
  width: auto;
  object-fit: contain;
}

.auth-title {
  font-size: 24px;
  font-weight: 800;
  margin: 0;
  background: linear-gradient(90deg, var(--brand), var(--brand-3));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
}

.auth-subtitle {
  font-size: 13.5px;
  color: var(--text-muted);
  text-align: center;
  margin-top: 6px;
  font-weight: 500;
}

.auth-btn {
  height: 48px !important;
  border-radius: 12px !important;
  text-transform: none;
  font-weight: 800;
  letter-spacing: 0.5px;
  font-size: 15px;
  color: #ffffff !important;
  background: linear-gradient(90deg, #4f008f 0%, #7c3aed 100%) !important;
  box-shadow: 0 10px 22px rgba(79, 0, 143, 0.35);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.auth-btn:not(.v-btn--disabled):hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 30px rgba(79, 0, 143, 0.4);
}

.auth-help-link {
  text-decoration: none;
  color: var(--brand);
  font-weight: 600;
  font-size: 13.5px;
  padding: 9px 18px;
  border-radius: 999px;
  background: var(--input-bg);
  border: 1px solid var(--brand-border);
  transition: all 0.18s ease;
}

a.auth-help-link:hover {
  background: var(--brand-soft-2);
  border-color: #d0bbf3;
}

.fade-up {
  animation: fadeUp 0.5s ease both;
}

.d2 {
  animation-delay: 0.1s;
}

.d3 {
  animation-delay: 0.18s;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fade-up,
  .login-card {
    animation: none;
  }
}
</style>
